import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getParametricFilters,
	getParametricSuppliersData,
	getParametricMaterialData,
	getParametricAttributeData,
	getParametricAttributeSelection,
} from "../../queries/apiQueries";
import { Button, SelectPicker, Modal, Notification, useToaster } from "rsuite";
import "./parametricAnalysis.scss";
import { FILTERDATA, TIMELINE } from "../../utils";
import AttributeSelection from "./attributeSelection";
import CostReduction from "./costReduction";
import ArowBackIcon from "@rsuite/icons/ArowBack";

import { appInsights } from "../router";
import MainHeader from "../../components/Layouts/MainHeader";
import ToggleSwitch from "../../components/common/ToggleSwitch";
import MainContent from "../../components/Layouts/MainContent";
import { Loader } from "../../components/common/Loader";
import { getTimelineOptions } from "../../config/constants";

const ParametricAnalysis = (props: any) => {
	const timelineOptions=getTimelineOptions()
	const dispatch = useDispatch<any>();
	const toaster = useToaster();
	const [filtersLoading, setFiltersLoading] = useState(true);
	const [buttonEnabled, setButtonEnabled] = useState(false);
	const [alert, setAlert] = useState(false);
	const [suppliersList, setSuppliersList] = useState<Array<any>>([]);
	const [materialData, setMaterialData] = useState<Array<any>>([]);
	const [materialCount, setMaterialCount] = useState<any>(null);
	const [materialPageNumber, setMaterialPageNumber] = useState(null);
	const [scatterData, setScatterData] = useState<Array<any>>([]);
	const [attributeData, setAttributeData] = useState<any>({});
	const [materialExportData, setMaterialExportData] = useState<any>([]);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const timeline = useSelector((state: any) => state.CommonReducer.timeline);

	const [selectedSupplier, setSelectedSupplier] = useState<any>(null);

	const [isLoading, setIsLoading] = useState(true);
	const [isVisible, setIsVisible] = useState(false);
	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		l4: new Array<{ l4: string }>(),
	});
	const [selectedFilters, setSelectedFilters] = useState<any>(allFilters);
	const [tableLoading, setTableLoading] = useState(false);
	const [page, setPage] = useState("attributeSelection");
	const [toggleChecked, setToggleChecked] = useState(false);

	const [selectedTimeline, setSelectedTimeline] = useState(
		timeline ? timeline : getTimelineOptions()[0]?.value
	);

	const didMount: any = useRef(false);

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to Parametric Analysis by ${localStorage.getItem(
				"name"
			)}`,
		});
		getFilters();
	}, []);

	useEffect(() => {
		if (selectedSupplier) {
			getMaterialData();
		}
	}, [selectedSupplier]);

	useEffect(() => {
		props.onTimelineChange(selectedTimeline);
		if (selectedTimeline && selectedFilters?.l4?.length == 1) {
			getSuppliersData();
			getAttributeData();
			if (selectedSupplier) {
				getMaterialData();
			}
		}
	}, [selectedTimeline]);

	useEffect(() => {
		if (materialPageNumber) {
			getMaterialData();
		}
	}, [materialPageNumber]);

	const getSuppliersData = async () => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
			timeline: selectedTimeline,
			pageNumber: [1],
			pageSize: [10],
		};
		let res = await dispatch(getParametricSuppliersData(payload));
		setSuppliersList(res.data);
	};

	const getMaterialData = async (isExport: boolean = false) => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
			timeline: selectedTimeline,
			master_vendor_name: [selectedSupplier],
			pageNumber: [materialPageNumber ? materialPageNumber : 1],
			pageSize: [10],
			isExport: isExport,
		};
		if (isExport) {
			toaster.push(message, { placement: "topCenter" });
		}
		let res = await dispatch(getParametricMaterialData(payload));
		if (isExport) {
			setMaterialExportData(res.data);
		} else {
			setMaterialData(res.data);
			setMaterialCount(res.count);
			setScatterData(res.scatterData);
		}
	};

	const getAttributeData = async () => {
		setIsLoading(true);
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
			timeline: selectedTimeline,
			pageNumber: [1],
			pageSize: [10],
		};
		let res = await dispatch(getParametricAttributeData(payload));
		setAttributeData(res);
		setIsLoading(false);
	};

	const getAttributSelection = async (payload: any = {}) => {
		setIsLoading(true);

		let res = await dispatch(getParametricAttributeSelection(payload));

		console.log("attributeData", attributeData);
		if (res?.data) {
			const selectedButton: any = payload.selected_attr[0];

			let tmp: any = attributeData;

			tmp?.data?.final_dict?.map((item: any, index: any) => {
				if (item.Attribute === selectedButton) {
					tmp.data.final_dict[index].scatterData =
						res.data.scatterData;
					tmp.data.final_dict[index].selected = true;
				}
			});
			setAttributeData(JSON.parse(JSON.stringify(tmp)));
		}

		setIsLoading(false);
	};

	const handleButtonClick = (selectedItem: any) => {
		let payload = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			l4: selectedFilters.l4,
			timeline: selectedTimeline,
			selected_attr: [selectedItem],
			pageNumber: [1],
			pageSize: [10],
		};

		let temp: any = attributeData;

		temp?.data?.final_dict?.map((item: any, index: any) => {
			if (item.Attribute === selectedItem) {
				if (item.selected) {
					temp.data.final_dict[index].selected = false;
					setAttributeData(JSON.parse(JSON.stringify(temp)));
				} else if (item.scatterData) {
					temp.data.final_dict[index].selected = true;
					setAttributeData(JSON.parse(JSON.stringify(temp)));
				} else {
					getAttributSelection(payload);
				}
			}
		});
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		setFiltersLoading(true);
		let res = await dispatch(getParametricFilters(payload));
		if (fo) {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...fo,
					l4: [...res.l4],
				});
			} else if (currentFilter === "l4") {
				updateFilterOptions({
					...fo,
				});
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					l4: res.l4,
				});
			}
		} else {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
					l4: [...res.l4],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({
					...filterOptions,
					l4: [...res.l4],
				});
			} else if (currentFilter === "l4") {
				updateFilterOptions({
					...filterOptions,
				});
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
					l4: res.l4,
				});
			}
		}

		setIsLoading(false);
		setFiltersLoading(false);
		return res;
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		let x: string = filter;
		setSelectedFilters({ ...selectedFilters, [x]: [value] });
		selectedFilters[x] = [value];
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		if (filter === "l1") {
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [], l4: [] });
			getFilters({ ...selectedFilters, l2: [], l3: [], l4: [] }, "l1");
		} else if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l3: [], l4: [] });
			getFilters({ ...selectedFilters, l3: [], l4: [] }, "l2");
		} else if (filter === "l3") {
			setSelectedFilters({ ...selectedFilters, l4: [] });
			getFilters({ ...selectedFilters, l4: [] }, "l3");
		} else if (filter === "l4") {
			// setIsLoading(true);
			setSelectedFilters({ ...selectedFilters });
			if (selectedFilters.l4.length == 1) {
				getSuppliersData();
				setSelectedSupplier(null);
				// getMaterialData();
				getAttributeData();
			}
		}
	};

	useEffect(() => {
		if (!didMount.current) {
			getFilters().then((options: any) => {
				if (selectedFilters?.l4.length > 0) {
					getFilters(selectedFilters, "l4", options);
				} else if (selectedFilters?.l3.length > 0) {
					getFilters(selectedFilters, "l3", options);
				} else if (selectedFilters?.l2.length > 0) {
					getFilters(selectedFilters, "l2", options);
				} else if (selectedFilters?.l1.length > 0) {
					getFilters(selectedFilters, "l1", options);
				}
			});
			// getSummaryData();
			didMount.current = true;
			getSuppliersData();
			// getMaterialData();
			getAttributeData();
		} else {
			props.onFilterChange(selectedFilters);
		}
	}, [selectedFilters]);

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setToggleChecked(event.target.checked);
		setPage(event.target.checked ? "costReduction" : "attributeSelection");
	};

	return isLoading ? (
		<Loader />
	) : (
		<>
			<div className="parametric-analysis-container w-full h-[100%]">
				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<ToggleSwitch
							checked={toggleChecked}
							onChange={handleToggleChange}
							leftText="Attribute Selection"
							rightText="Cost Reduction"
						/>
					}
					bottomContent={
						<>
							<div className="filterHeader font-bold flex flex-col items-start">
								<span className="capitalize text-black text-[0.7vw]">
									Timeline
								</span>
								<SelectPicker
									data={
										timelineOptions.length
											? timelineOptions
											: []
									}
									placeholder="All"
									value={selectedTimeline}
									defaultValue={
										timelineOptions.length
											? timelineOptions[0].value
											: ""
									}
									onChange={timelineHandler}
									cleanable={false}
								/>
							</div>
							{["l1", "l2", "l3", "l4"].map((filterEntity) => (
								<div
									key={filterEntity}
									className="filterHeader flex flex-col items-start"
								>
									<span className="capitalize text-black text-[0.7vw]">
										{filterEntity}
									</span>
									<SelectPicker
										data={
											filterOptions[filterEntity].length
												? filterOptions[filterEntity]
												: []
										}
										disabled={buttonEnabled}
										labelKey={
											filterEntity === "supplier"
												? "vendor"
												: filterEntity
										}
										valueKey={
											filterEntity === "supplier"
												? "vendor"
												: filterEntity
										}
										value={
											selectedFilters[filterEntity]
												? selectedFilters[
														filterEntity
												  ][0]
												: []
										}
										cleanable={false}
										onClose={() =>
											handleClose(filterEntity)
										}
										onChange={(value) =>
											handleFilterUpdate(
												value,
												filterEntity
											)
										}
										loading={filtersLoading}
									/>
								</div>
							))}
						</>
					}
				></MainHeader>
				<MainContent isVisible={isVisible} fullHeight={true}>
					{selectedSupplier && page === "costReduction" && (
						<div
							className="backButton"
							onClick={() => {
								setSelectedSupplier(null);
							}}
						>
							<ArowBackIcon /> {` Supplier: ${selectedSupplier}`}
						</div>
					)}
					<div
						className={`chart-flex ${
							selectedSupplier ? "h-[88.5%]" : "h-[100%]"
						}`}
					>
						{page === "attributeSelection" ? (
							<AttributeSelection
								tableLoading={tableLoading}
								attributeData={attributeData}
								handleButtonClick={(item: any) => {
									handleButtonClick(item);
								}}
								selectedFilters={selectedFilters}
							/>
						) : (
							<CostReduction
								tableLoading={tableLoading}
								data={suppliersList}
								materialData={materialData}
								materialExportData={materialExportData}
								materialCount={materialCount}
								scatterData={scatterData}
								selectedSupplier={selectedSupplier}
								selectedFilters={selectedFilters}
								getMaterialData={() => getMaterialData(true)}
								updateSelectedSupplier={(supplier: any) => {
									if (supplier != selectedSupplier) {
										setSelectedSupplier(supplier);
									}
								}}
								updatePageNumber={(page: any) => {
									setMaterialPageNumber(page);
								}}
								pageNumber={materialPageNumber}
							/>
						)}
					</div>
				</MainContent>
			</div>
		</>
	);
};

const message = (
	<Notification type={"info"} header={`Exporting...`} closable>
		<p>Your file is being created. It will be download automatically</p>
	</Notification>
);

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => dispatch({ type: FILTERDATA, data: data }),
	onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});
export default connect(null, mapDispatchToProps)(ParametricAnalysis);
